// (function() {
//     window.addEventListener('load', function() {
//         alert('loaded');
//     });
// })();
$(function(){

	// ニューストップ ティッカー表示
	var swiper = new Swiper(".top_news_swiper", {
		loop: true,
		// autoHeight: true,
		autoplay: {
			delay: 4000,
		},
	});

	//メディア ループスライドショー PC
	if (window.matchMedia( "(min-width: 768px)" ).matches) {
		$('.enterprise_slider .Infiniteslide').infiniteslide({
			speed: 70,
			pauseonhover: false,
		});
	}
	//メディア ループスライドショー SP
	if (window.matchMedia( "(max-width: 768px)" ).matches) {
		$('.enterprise_slider .Infiniteslide').infiniteslide({
			speed: 50,
			pauseonhover: false,
		});
	}

	//メンバー ループスライドショー PC
	if (window.matchMedia( "(min-width: 768px)" ).matches) {
		$('.member_slider .Infiniteslide').infiniteslide({
			speed: 50,
			pauseonhover: false,
			clone: 3,
		});
	}
	//メンバー ループスライドショー SP
	if (window.matchMedia( "(max-width: 768px)" ).matches) {
		$('.member_slider .Infiniteslide').infiniteslide({
			speed: 30,
			pauseonhover: false,
			clone: 3,
		});
	}

});